import noticeInfoStyles from './notice-info.module.scss';
import { src } from '../../../utils/common';
import router from 'next/router';
import { dateFormat } from '/utils/filters/moment';
import { WebPNativeImage } from '../../WebPImage';

export default function NoticeInfo(props) {
  const { time, desc, hot } = props.item;
  return (
    <div className={noticeInfoStyles.container}>
      <div className={noticeInfoStyles.info}>
        <div
          className={noticeInfoStyles.desc}
          // onClick={() => router.push('/support/bulletin/zuihrf')}
        >
          <span>{desc}</span>
          {hot && (
            <WebPNativeImage
              src={src('/img/doc-center/hot.svg')}
              className={noticeInfoStyles.hotSpace}
              alt="hotIcon"
            />
          )}
        </div>

        {time && (
          <div className={noticeInfoStyles.time}>{dateFormat(time)}</div>
        )}
      </div>
    </div>
  );
}
